export default __webpack_public_path__ + "static/AC_Parallax_Backward-ccc3acce381a02c1f98808c935690b11.jpg";